interface SignupVerificationStepProps {
  styles: Record<string, string>;
  email: string;
  errorMessage: string;
  verificationNotice: string;
  loading: boolean;
  onResendVerification: () => void;
  onBackToLogin: () => void;
}

export default function SignupVerificationStep({
  styles,
  email,
  errorMessage,
  verificationNotice,
  loading,
  onResendVerification,
  onBackToLogin,
}: SignupVerificationStepProps) {
  return (
    <div className={styles.rightPanel}>
      <div className={styles.formCard}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}></div>
          <h2 className={styles.formTitle}>Verify Your Email</h2>
          <p className={styles.formSubtitle}>We sent a verification link to:</p>
          <p className={styles.verificationEmail}>
            {email}
          </p>
        </div>

        {errorMessage && (
          <div className={styles.errorMsg} style={{ marginBottom: '1.5rem' }}>
            {errorMessage}
          </div>
        )}

        {verificationNotice && (
          <div className={styles.successMsg} style={{ marginBottom: '1.5rem' }}>
            {verificationNotice}
          </div>
        )}

        <div className={styles.verificationCopy}>
          <p style={{ marginBottom: '1rem' }}>
            Click the verification link in your email to activate your account.
          </p>
          <p style={{ marginBottom: '1rem' }}>
            After verification, you can sign in and start using VerdeKai.
          </p>
          <p className={styles.fieldHint} style={{ marginLeft: 0 }}>
            Don&apos;t see the email? Check your spam folder or click below to resend.
          </p>
        </div>

        <button
          type="button"
          className={styles.signInBtn}
          onClick={onResendVerification}
          disabled={loading}
          style={{ marginBottom: '1rem' }}
        >
          {loading ? 'Sending...' : 'Resend Verification Email'}
        </button>

        <button
          type="button"
          className={styles.secondaryActionBtn}
          onClick={onBackToLogin}
        >
          Back to Sign In
        </button>

        <div className={styles.signupPrompt} style={{ marginTop: '2rem' }}>
          Need help? <a href="mailto:support@verdekai.com">Contact Support</a>
        </div>
      </div>
    </div>
  );
}
